import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faLock, faShieldAlt, faArrowRight, faWarning } from "@fortawesome/free-solid-svg-icons";

import { Header } from "../../components/header/header";
import { SecService } from "../../components/services/security-info";
import { ServiceHeader } from "../../components/services/service-header";
import InViewPort from "../../components/utilities/in-viewport";
import { secFramework, secProcesses } from "../../_helpers/mock-data";
import { GenLeft } from "../../components/utilities/service-framer";
import SlideRight from "../../components/utilities/right-shift";
import { secUseCases } from "../../_helpers/mobi-use";
import { SecurityData } from "../../components/services/mobi-service";
import { Footer } from "../../components/footer/footer";
import { compliance } from "../../_helpers/mock-data";
import { ComplianceObject } from "../../components/services/tech-stack";

export const CyberSecurity = () => {
    return (
        <div className="rand-page">
            <Header pageTitle={"Cyber Security Services"} />
            <ServiceHeader
                gradText={"AI-Driven"}
                normText={"Cyber Security"}
                descr={"Protect your digital assets with intelligent security solutions that learn, adapt, and defend against evolving cyber threats."}
                descrImg={"/images/cyber-security.jpeg"}
                fBtnCap={"Secure Now"}
                sBtnCap={"Security Audit"}
                fColor={"#c43c16ff"}
                sColor={"#cc5439ff"}
            />
            <InViewPort>
                <div className="page-sub-cap">
                    <span className="norm-text">Intelligent</span>
                    <span className="gradient-text">Security Soluions</span>
                </div>
                <div className="descr flx-rw-c">
                    Comprehensive AI-powered cybersecurity services that stay ahead of emerging threats
                </div>
            </InViewPort>
            <div className="services-box">
                <SecService
                    topic={"AI Threat Detection"}
                    textDesc={"Advanced machine learning algorithms that identify and neutralize threats in real-time"}
                    icon={faShieldAlt}
                />
                <SecService
                    topic={"Smart Authentication"}
                    textDesc={"Biometric and behavioral AI authentication systems for enhanced security"}
                    icon={faLock}
                />
                <SecService
                    topic={"Intelligent Monitoring"}
                    textDesc={"24/7 AI-powered surveillance and anomaly detection across all systems"}
                    icon={faEye}
                />

                <SecService
                    topic={"Predictive Security"}
                    textDesc={"AI models that predict and prevent security breaches before they occur"}
                    icon={faWarning}
                />
            </div>
            <InViewPort>
                <div className="page-sub-cap">
                    <span className="norm-text">AI-Powered </span>
                    <span className="gradient-text">Defence</span>
                </div>
                <div className="descr flx-rw-c">
                    Advanced artificial intelligence capabilities that revolutionize cybersecurity
                </div>
            </InViewPort>
            <div className="services-box">
                {secProcesses.map((process, indx) => (
                    <SlideRight key={indx}>
                        <div className="process-unit">
                            <div className="or-bg gen-proc-circle">
                                <FontAwesomeIcon icon={process.icon} />
                            </div>
                            <div className="process-caption">{process.caption}</div>
                            <div className="process-descr">{process.descr}</div>
                        </div>
                    </SlideRight>
                ))}
            </div>
            <InViewPort>
                <div className="page-sub-cap">
                    <span className="norm-text">Modern </span>
                    <span className="gradient-text">Threat Detection</span>
                </div>
            </InViewPort>
            <div className="services-box">
                {secUseCases.map((useCase, k) => (
                    <SecurityData
                        caption={useCase.caption}
                        message={useCase.message}
                        stat={useCase.stat}
                        key={k}
                    />
                ))}
            </div>
            <InViewPort>
                <div className="page-sub-cap">
                    <span className="norm-text">Security </span>
                    <span className="gradient-text">Framework</span>
                </div>
            </InViewPort>
            <div className="services-box">
                {compliance.map((stack, k) => (
                    <ComplianceObject stack={stack} key={k} />
                ))}
            </div>
            <InViewPort>
                <div className="page-sub-cap">
                    <span className="norm-text">Security </span>
                    <span className="gradient-text">Framework</span>
                </div>
            </InViewPort>
            <div className="services-box">
                {secFramework.map((process, indx) => (
                    <GenLeft key={indx}>
                        <div className="process-unit">
                            <div className="gen-num-circle or-bg">0{indx + 1}</div>
                            <div className="process-caption">{process.caption}</div>
                            <div className="process-descr">{process.descr}</div>
                        </div>
                    </GenLeft>
                ))}
            </div>
            <InViewPort>
                <div className="offer-bx glassy-effect">
                    <div className="q-cap">
                        <span className="norm-text of-cap">Secure Your</span>
                        <span className="gradient-text of-cap"> Digital Future</span>
                    </div>
                    <div className="descr">
                        Don't wait for a breach. Protect your organization with AI-powered cybersecurity today
                    </div>
                    <div className="bttn">
                        <button className="gen-of-btn or-bg">
                            <span className="of-btn-txt">Secure Your Business</span>
                            <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                    </div>

                </div>
            </InViewPort>
            <Footer />
        </div>
    )
}